import { alpha, Button, styled } from '@mui/material';

export const LanguageSelectorButton = styled(Button)(({ theme }) => ({
  border: `1px solid ${alpha(theme.palette.common.black, 0.23)}`,
}));
